var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEcommerce(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "30px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;stroke:#e0e0e0cc;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.5px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ic-ecommerce-cart"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vrstva_536",
    "data-name": "Vrstva 536"
  }, /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "1.68 2.77 5.18 2.77 8.34 16.48 21 16.48 22.32 6.72 6.09 6.72"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 9.3,
    y: 18.62,
    width: 2.61,
    height: 2.61,
    rx: 1.3
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 9.3,
    y: 18.62,
    width: 2.61,
    height: 2.61,
    rx: 1.3
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 16.16,
    y: 18.62,
    width: 2.61,
    height: 2.61,
    rx: 1.3
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEcommerce);
export default __webpack_public_path__ + "static/media/ecommerce.f5cb9e71d50ccd0e4a52019784a3d530.svg";
export { ForwardRef as ReactComponent };